import styled, { css, keyframes } from "styled-components";
import { Wrapper } from 'AppReact';
import { colorShade } from "utils";

const hideSmall = keyframes`
  from {
    transform: translate(0px);
  }

  to {
    transform: translate(541px);
  }
`;

const showSmall = keyframes`
  from {
    transform: translate(541px);
  }

  to {
    transform: translate(0px);
  }
`;


const hideSmallMobile = keyframes`
  from {
    transform: translate(0px);
  }

  to {
    transform: translate(100%);
  }
`;

const showSmallMobile = keyframes`
  from {
    transform: translate(100%);
  }

  to {
    transform: translate(0px);
  }
`;


const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    position: absolute;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 4px 60px rgba(4, 51, 59, 0.12);
    right: 0px;
    top: 0px;
    width: calc(100% - 48px);
    height: 100vh;
    background-color: ${colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')};
    padding: 40px 20px;
    z-index: 10;

    ${!displayState.isVisible && css`
      animation: ${hideSmallMobile} 0.5s forwards ease-in-out;
    `}
    ${displayState.isVisible && css`
      animation: ${showSmallMobile} 0.5s forwards ease-in-out;
    `}

    @media (min-width: 768px) {
      width: 541px;
      ${!displayState.isVisible && css`
        animation: ${hideSmall} 0.5s forwards ease-in-out;
      `}
      ${displayState.isVisible && css`
        animation: ${showSmall} 0.5s forwards ease-in-out;
      `}
    }

    @media (min-width: 1320px) {
      position: relative;
      box-shadow: none;
    }

    @media (min-width: 1560px) {
      padding-top: 67px;
      padding-left: 45px;
      padding-right: 45px;
      position: relative;
    }
  `}
`;

export default Wrapper(template);